<template>
	<div class="">
		<div id="contnChow123" ref="mapContainer"></div>
	</div>
</template>

<script>
	import AMapLoader from "@amap/amap-jsapi-loader";
	import {
		transformWGS84ToBD09,
		transformBD09ToGCJ02,
		transformBD09ToWGS84,
		transformGCJ02ToWGS84,
		transformWGS84ToGCJ02,
	} from "@isvend/coord-transform";
	export default {
		components: {},
		props: {
			zoom: {
				type: Number,
			},
		},
		data() {
			return {
				markersWaterSet: [],
				markersGroupList: [],
				groupPolyline: null,
				map: null,
				markers: [],
			};
		},
		async mounted() {
			this.$request("iot/map/water").then((res) => {
				this.initMap(res.data);
			});
		},
		// 生命周期 - 挂载完成（可以访问DOM元素）
		// mounted() {

		// },
		methods: {
			initMap(mapData) {
				let that = this;
				return new Promise((resolve) => {
					window._AMapSecurityConfig = {
						securityJsCode: "3a7d5f7b5bc50ae4143e3ae4f39ab361", // 自2021年12月02日升级后, key与安全密钥必须一起使用, 否则可能会出现一些API无法使用，如 DistrictSearch
					};
					AMapLoader.load({
							key: "b9616423933ca61420aac81305b6d75c", // 首次调用 load 时必填
							version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
							plugins: [
								"AMap.DistrictSearch", // 配置行政区查询服务
								"AMap.GeoJSON", // 配置行政区查询服务
							], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
							Loca: {
								// 是否加载 Loca， 缺省不加载
								version: "2.0.0", // Loca 版本，缺省 1.3.2
							},
						})
						.then((AMap) => {
							this.googleSatelliteDomestic = new AMap.TileLayer({
								tileUrl: "https://map.snkoudai.com/maps/vt/lyrs=s&hl=zh-CN&gl=cn&scale=1&x=[x]&y=[y]&z=[z]",
							});

							var imageLayer = new AMap.ImageLayer({
								url: "https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E6%B0%B4%E9%98%80%E5%9B%BE%403x.png",
								bounds: new AMap.Bounds(
									[100.348928, 38.897934],
									[100.378626, 38.914551]
								),
								zooms: [15, 20],
								zIndex: 150,
							});

							//基础图层
							this.map = new AMap.Map("contnChow123", {
								center: [100.362315, 38.904672], // 中心点坐标
								mapStyle: "amap://styles/darkblue", //地图颜色样式
								viewMode: "3D", //是否启用3d地图
								pitch: 50, //设置倾斜度
								// zoom: 7.7,
								zoom: 16,
								skyColor: "#395a85", //天空颜色
								resizeEnable: true,
								showLabel: false,
								layers: [this.googleSatelliteDomestic],
								animateEnable: true,
							});

							//画在地图图层上,map是地图对象
							var mapOverLayer = new AMap.OverlayGroup();
							this.map.add(mapOverLayer); //新建图层，将图层添加到地图上

							var dkColor = [
								"rgb(37, 170, 128)",
								"#7ebe7a",
								"#6c924f",
								"#3f8a3b",
							];
							for (let i = 0; i < mapData.length; i++) {
								let data = JSON.parse(mapData[i].latLonPath);
								var polygon = new AMap.Polygon({
									path: data.map((item) => {
										return [item.longitude, item.latitude];
									}),
									strokeColor: "#fff",
									strokeWeight: 2,
									strokeOpacity: 1,
									// strokeStyle: 'dashed',
									fillColor: dkColor[i],
									fillOpacity: 0.5,
									lineJoin: "round", //折线拐点的绘制样式，默认值为'miter'尖角，其他可选值：'round'圆角、'bevel'斜角
									lineCap: "round", //折线两端线帽的绘制样式，默认值为'butt'无头，其他可选值：'round'圆头、'square'方头
									extData: mapData[i],
								});
								this.map.add(polygon);
								// polygon.on("click", function (e) {
								//   that.$router.push("farming");
								// });

								let poliList = mapData[i].waterPipe.split("#");
								for (let j = 0; j < poliList.length; j++) {
									let data2 = JSON.parse(poliList[j]);
									let path = data2.map((item) => {
										return [item.longitude, item.latitude];
									});

									// var Polyline = new AMap.Polyline({
									//   path: data2.map((item) => {
									//     return [item.longitude, item.latitude];
									//   }),
									//   strokeWeight: 12,
									//   // strokeColor: dkColor[i],
									//   strokeColor: "#97EDFF",
									//   // 使用纹理线
									//   lineJoin: "round",
									//   lineCap: "round",
									//   strokeDasharray: [10, 5], // 虚线间隔
									//   showDir: true,
									//   isOutline: true,
									//   outlineColor: "#fff",
									//   zIndex: 90,
									// });
									// this.map.add(Polyline);

									// var Polyline2 = new AMap.Polyline({
									//   path: data2.map((item) => {
									//     return [item.longitude, item.latitude];
									//   }),
									//   strokeWeight: 6,
									//   // strokeColor: dkColor[i],
									//   strokeColor: "#005ACF",
									//   strokeOpacity: 0.3,
									//   // 使用纹理线
									//   lineJoin: "round",
									//   lineCap: "round",
									//   strokeDasharray: [10, 5], // 虚线间隔
									//   showDir: true,
									//   isOutline: true,
									//   outlineColor: "blue",
									//   zIndex: 91,
									// });
									// this.map.add(Polyline2);
								}
							}

							var markerIcon = new AMap.Icon({
								size: new AMap.Size(134, 134),
								image: "https://ica.obs.cn-south-1.myhuaweicloud.com/screen/home/%E5%8F%8C%E5%A0%A1%E6%9D%91%E5%9C%B0%E5%9D%80%402x.png",
								imageSize: new AMap.Size(134, 134),
								// 图标取图偏移量
								imageOffset: new AMap.Pixel(-9, -3),
							});

							var markers = new AMap.Marker({
								position: [100.362315, 38.904672],
								icon: markerIcon,
								offset: new AMap.Pixel(-62, -104),
							});
							this.map.add(markers);

							//右键单击也可以返回
							markers.on("click", (e) => {
								this.map.setZoom(15);
								this.map.setCenter([100.362315, 38.904672]);
							});

							// 点标记显示内容，HTML要素字符串
							var markerContent =
								"" +
								'<div class="custom-content-marker"><div>张掖市</div><div>zhangye</div></div>';
							var marker = new AMap.Marker({
								position: [101.262315, 40.504672],
								// 将 html 传给 content
								// content: markerContent,
								icon: "https://ica.obs.cn-south-1.myhuaweicloud.com/screen/home/%E5%BC%A0%E6%8E%96%E5%B8%82.png",
								// 以 icon 的 [center bottom] 为原点
								offset: new AMap.Pixel(-13, -30),
							});

							// 将 markers 添加到地图
							this.map.add(marker);
							marker.on("click", (e) => {
								//打开制种玉米弹窗
								this.zzym = true;
							});

							this.map.on("complete", () => {
								resolve();
								this.getBoundaries(AMap, this.map);
							});
							this.map.on("click", function(e) {
								console.log(e);
							});
						})
						.catch((e) => {
							console.log(e);
						});
				});
			},
			// 2.获取边界
			getBoundaries(AMap, map) {
				const district = new AMap.DistrictSearch({
					subdistrict: 0,
					// 返回行政区边界坐标点
					extensions: "all",
				}); //注意：需要使用插件同步下发功能才能这样直接使用
				district.search("张掖市", (status, result) => {
					if (status == "complete") {
						var loca = (window.loca = new Loca.Container({
							map,
						}));

						var ambLight = new Loca.AmbientLight({
							intensity: 1,
							color: "#fff",
						});
						loca.addLight(ambLight);

						fetch(
								"https://qgst.obs.cn-southwest-2.myhuaweicloud.com/rabbit/pc/geoJson/%E7%94%98%E8%82%83%E7%9C%813.geoJson"
							)
							.then((response) => response.json())
							.then((dataJSON) => {
								var geo = new Loca.GeoJSONSource({
									data: dataJSON,
									// url:'https://a.amap.com/Loca/static/loca-v2/demos/mock_data/hz_gn.json'
								});
								// var height = [10, 20, 40, 60, 80, 100, 120, 140, 160];
								// height = height.map(h => h * 2)
								var pl = new Loca.PolygonLayer({
									zIndex: 100,
									cullface: "none",
									shininess: 1,
									hasBottom: false,
									blockHide: false,
									hasSide: true,
									hasTop: false,
									depth: false,
								});

								pl.setSource(geo);
								pl.setStyle({
									topColor: function(index, feature) {
										return "rgba(255,255,255,1)";
									},
									sideTopColor: function(index, feature) {
										return "rgba(255,255,255,0.6)";
									},
									height: function(index, feature) {
										var v = feature.properties.health * 160;
										// return v * v;
										return 15000;
									},
								});
								loca.add(pl);
							});

						var outer = [
							new AMap.LngLat(-360, 90, true),
							new AMap.LngLat(-360, -90, true),
							new AMap.LngLat(360, -90, true),
							new AMap.LngLat(360, 90, true),
						];
						var holes = result.districtList[0].boundaries;

						var pathArray = [outer];
						pathArray.push.apply(pathArray, holes);
						var polygon = new AMap.Polygon({
							pathL: pathArray,
							strokeColor: "#00eeff",
							strokeWeight: 1,
							fillColor: "#233622",
							fillOpacity: 0.8,
						});
						polygon.setPath(pathArray);
						this.map.add(polygon);
					}
				});
			},
			setMarkers(e) {
				let that = this;
				if (this.markers && this.markers.length > 0) {
					this.markers.forEach((marker) => {
						marker.setMap(null); // 或者 marker.remove();
					});
					this.markers = []; // 清空数组，准备下次使用
				}

				for (let i = 0; i < e.data.length; i++) {
					var image ="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/%E5%A2%92%E6%83%85%E8%AF%8A%E6%96%AD/%E5%90%AB%E6%B0%B4%E9%87%8F%402x.png";
					// switch (e.data[i].status) {
					// 	case 0:
					// 	case 1:
					// 		image =
					// 			"https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/%E5%A2%92%E6%83%85%E8%AF%8A%E6%96%AD/%E8%92%B8%E8%85%BE%E9%87%8F%402x%20%281%29.png";
					// 		break;
					// 	case 2:
					// 		image =
					// 			"https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/%E5%A2%92%E6%83%85%E8%AF%8A%E6%96%AD/%E5%90%AB%E6%B0%B4%E9%87%8F%402x.png";
					// 		break;
					// 	case 3:
					// 		image =
					// 			"https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/%E5%A2%92%E6%83%85%E8%AF%8A%E6%96%AD/%E5%90%AB%E6%B0%B4%E9%87%8F%402x.png";
					// 		break;
					// 	case 4:
					// 		image =
					// 			"https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/%E5%A2%92%E6%83%85%E8%AF%8A%E6%96%AD/%E5%90%AB%E6%B0%B4%E9%87%8F%402x.png";
					// 		break;
					// 	default:
					// 		break;
					// }
					var markerIcon = null;
					markerIcon = new AMap.Icon({
						size: new AMap.Size(42, 96),
						image: image,
						imageSize: new AMap.Size(42, 96),
						// 图标取图偏移量
						// imageOffset: new AMap.Pixel(-20, -20),
					});

					var markers = new AMap.Marker({
						position: [e.data[i].lon, e.data[i].lat],
						icon: markerIcon,
						offset: new AMap.Pixel(-21, -96),
						extData: e.data[i],
					});
					markers.on("click", function(e) {
						var data = e.target.getExtData();
					});

					//marker移动到上面展示项目概况信息
					markers.on("mouseover", (e) => {
						let da = e.target.getExtData();
						var html =
							"<div  style='height: 160px;min-width:300px;background-color: rgba(0, 50, 119, 0.80);border: 1px solid;border-image: linear-gradient(50deg, rgba(1, 194, 255, 0.5), rgba(1, 194, 255, 1)) 1 1;display: flex;box-shadow: 0 1px 6px 0 rgba(255, 255, 255, 0.3);'>" +
							"<div style='flex: 1;display: flex;flex-direction: column;justify-content: center;margin-left: 10px;margin-right: 10px;'>" +
							"<div style='font-size: 15px;color: rgba(255,255,255,0.8);'>位置：E" +
							da.lon + '°,N' + da.lat +
							"°</div>" +
							"<div style='font-size: 15px;color: rgba(255,255,255,0.8);text-overflow:ellipsis;white-space:nowrap;margin:5px 0;'>深度：" +
							da.depth +
							"</div>" +
							"<div style='font-size: 15px;color: rgba(255,255,255,0.8);'>水分：" +
							da.dew +
							"</div>" +
							"<div style='font-size: 15px;color: rgba(255,255,255,0.8);margin:5px 0;'>状态：" +
							da.ment +
							" </div>" +
							"<div class='flex alit' style='font-size: 15px;color: rgba(255,255,255,0.8);margin:5px 0;'>建议：<div class='jianyi'>" +
							da.suggest +
							"</div></div>" +
							"</div>" +
							"</div>";

						//创建信息窗体
						var infoWindow = new AMap.InfoWindow({
							isCustom: true, //使用自定义窗体
							content: html, //信息窗体的内容可以是任意html片段
							offset: new AMap.Pixel(200, 40), //偏移位置
							closeWhenClickMap: false,
						});

						this.projectOverviewRelatedInfo = da;
						infoWindow.open(this.map, e.target.getPosition()); //e.target.getPosition()为marker对应坐标
						this.infoWindowLayer = infoWindow;
					});

					//移动开关闭
					markers.on("mouseout", (e) => {
						this.infoWindowLayer.close();
					});
					this.map.add(markers);
					this.markers.push(markers);
				}
			},
			changeStatus(e) {
				switch (e) {
					case 1:
						return "已完成";
						break;
					case 2:
						return "进行中";
						break;
					case 3:
						return "未开始";
						break;
					case 4:
						return "已超期";
						break;
				}
			},
		},
	};
</script>
<style>
	.jianyi {
		font-family: YouSheBiaoTiHei, YouSheBiaoTiHei;
		font-weight: 400;
		font-size: 20px;
		color: #EDFBFF;
		background: linear-gradient(180deg, #FFF600 30%, #fffff3 60%);
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
	}
</style>
<style lang="scss" scoped>
	.sqtext {
		font-size: 16px;
		color: #fff;
		line-height: 40px;
		padding-left: 10px;
	}

	.dialog {
		width: 100vw;
		height: 100vh;
		position: fixed;
		top: 0;
		left: 0;
		z-index: 1500;

		.dialog-close {
			width: 30px;
			height: 30px;
			position: absolute;
			right: 20px;
			top: 10px;
			z-index: 99;
			cursor: pointer;
		}

		.table-name {
			font-size: 20px;
		}

		.table-search {
			font-size: 15px;
		}

		/* 移除所有内部边框 */
		.outer-border-table>>>.el-table__body tr td,
		.outer-border-table>>>.el-table__body tr th,
		.outer-border-table>>>.el-table__header-wrapper tr th {
			border: none !important;
		}

		/* 添加外边框 */
		.outer-border-table {
			border: 1px solid #ebeef5;
			border-radius: 4px;
		}

		/* 移除默认的表格边框 */
		.outer-border-table>>>.el-table__header,
		.outer-border-table>>>.el-table__body,
		.outer-border-table>>>.el-table__footer {
			border: none !important;
		}

		.search {
			height: 31px;
			line-height: 31px;
			background: #366ec0;
			border-radius: 4px;
			text-align: center;
			font-family: PingFangSC, PingFang SC;
			font-weight: 500;
			font-size: 14px;
			color: #ffffff;
			margin-right: 10px;
			padding: 0 10px;
			cursor: pointer;
		}

		.search2 {
			height: 31px;
			background: #366ec0;
			border-radius: 4px;
			text-align: center;
			font-family: PingFangSC, PingFang SC;
			font-weight: 500;
			font-size: 14px;
			color: #ffffff;
			margin-right: 10px;
			padding: 0 10px;
			cursor: pointer;
		}

		.mask {
			width: 100vw;
			height: 100vh;
			z-index: 1500;
			background-color: rgba(0, 0, 0, 0.3);
			position: absolute;
		}

		.cont {
			position: relative;
			z-index: 1501;
			background-color: #fff;
			border-radius: 20px;
		}
	}

	.custom-content-marker {
		font-weight: 900;
		font-size: 36px;
		color: #f6e18b;
		text-shadow: 0px 4px 10px rgba(0, 0, 0, 0.3);
		width: 200px;
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	#contnChow123 {
		border-radius: 5px;
		width: 100vw;
		height: 100vh;
		position: relative;

		color: #7ebe7a;
	}

	.cq {
		.sd {
			width: 90px;
			height: 30px;
			background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/%E6%89%8B%E5%8A%A8%402x%20%282%29.png");
			background-size: 100% 100%;

			font-weight: 500;
			font-size: 14px;
			color: #fff;
			line-height: 30px;
			text-align: center;
		}

		.zd {
			width: 90px;
			height: 30px;
			background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/%E8%87%AA%E5%8A%A8%402x%20%281%29.png");
			background-size: 100% 100%;

			font-weight: 500;
			font-size: 14px;
			color: #fff;
			line-height: 30px;
			text-align: center;
		}

		/* 修改选中时的背景色 */
		::v-deep .el-switch.is-checked .el-switch__core {
			background-color: rgba(0, 180, 255, 0.4) !important;
			border-color: #53c556 !important;
		}

		/* 修改未选中时的背景色 */
		::v-deep .el-switch__core {
			background-color: #a19f9f !important;
			// border-color: #b2b2b2 !important;
		}

		.ai-list {
			width: 620px;
			height: 36px;
			background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/ai%E4%BF%A1%E6%81%AF%E6%A0%8F%402x.png");
			background-size: 100% 100%;

			font-weight: 400;
			font-size: 14px;
			color: #ffffff;
			text-align: center;
		}

		.aifx-title {
			width: 620px;
			height: 36px;
			background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/ai%E6%A0%87%E9%A2%98%E6%A0%8F%402x.png");
			background-size: 100% 100%;

			font-weight: 500;
			font-size: 14px;
			color: #00ffd1;
			text-align: center;
		}

		.el-input__inner {
			background: linear-gradient(180deg,
					rgba(0, 87, 202, 0.3) 0%,
					rgba(0, 23, 54, 0.64) 100%) !important;
			border-radius: 2px !important;
			border: 1px solid !important;
			border-image: linear-gradient(124deg,
					rgba(156, 211, 225, 0),
					rgba(194, 243, 255, 1),
					rgba(156, 211, 225, 0)) 1 1 !important;
		}

		::v-deep .el-range-input {
			background: rgba(156, 211, 225, 0) !important;
			cursor: pointer;
		}

		::v-deep .el-range-separator {
			color: #fff !important;
		}

		.cjsj {
			font-weight: 400;
			font-size: 14px;
			color: #ffffff;
			margin-right: 10px;
		}

		.search {
			width: 73px;
			height: 31px;
			background: #366ec0;
			border-radius: 2px;

			font-family: PingFangSC, PingFang SC;
			font-weight: 500;
			font-size: 14px;
			color: #ffffff;
		}

		.cq-right-top-title2 {
			font-weight: 400;
			font-size: 14px;
			color: #ffffff;
			margin-right: 2px;
			width: 60px;
		}

		.cq-right-top-title {
			font-weight: 400;
			font-size: 14px;
			color: #ffffff;
			margin-right: 12px;
			width: 60px;
		}

		.switch-group {
			display: flex;
			flex-direction: column;
			/* 垂直方向 */
			align-items: center;
			/* 居中对齐 switch 与文字 */
			margin-top: -20px;
		}

		.cq-right-top-status {
			// font-weight: 400;
			font-size: 14px;
			color: #ffffff;
			margin-bottom: 4px;
			/* 状态文字与 switch 间距 */
		}

		.paizhao {
			width: 88px;
			height: 30px;
			background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/%E6%8B%8D%E7%85%A7%E8%83%8C%E6%99%AF%402x.png");
			background-size: 100% 100%;

			font-weight: 400;
			font-size: 14px;
			color: #ffffff;
			margin-right: 20px;
		}
	}

	.fout-emotions-title {
		height: 38px;
		background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/fourEmotions/%E6%A0%87%E9%A2%98%402x%20%281%29.png");
		background-size: 100% 100%;
		font-family: YouSheBiaoTiHei;
		font-size: 20px;
		color: #c4dcf0;
		line-height: 38px;
		padding-left: 30px;
	}
</style>